// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8UQS8","option":"styles_option__Opx8X","active":"styles_active__3vMvJ"};